import gameData from "others/game/gameData";
import { popupMessageRef } from 'components/PopupMessage/PopupMessage';
import { setMessage } from "components/StatusMessage/StatusMessage";
import { popupErrorRef } from "scenes/App/App";
import Cookies from 'universal-cookie';

export function setupOnRoomJoined(socket, setRoom){
    setupOnError(socket);
    
    socket.on('roomJoined', ({ room, player, data }) => {
        // Set room data
        const newRoom = {
            ...room,
            localPlayer: player,
            joined: true
        };
        setRoom(newRoom);
        gameData.data = data;

        //Set room cookie
        const cookie = new Cookies();
        cookie.set('mdc_room', {
            roomName: room.name,
            playerName: player.name
        }, { maxAge: 1000 * 60 * 60 });

        // Setup server messages listeners
        setupUpdateRoom(socket, setRoom);
        setupUpdateData(socket);
        setupMessage(socket);
        setupImportantMessage(socket);
        setupEndGame(socket);
        setupBecomeMaster(socket);
        setupFatalError(socket, setRoom);
    });
}

function setupUpdateRoom(socket, setRoom){
    socket.on('updateRoom', ({room, localPlayer, isMyTurn})=>{
        setRoom({
            ...room,
            localPlayer,
            isMyTurn
        });
    });
}

function setupUpdateData(socket){
    socket.on('updateData', data=>{
        gameData.data = {
            ...gameData.data,
            ...data
        };
    });
}

function setupBecomeMaster(socket) {
    socket.on('becomeMaster', ()=>{
        gameData.data.isRoomMaster = true;
    })
}

function setupMessage(socket){
    socket.on('message', ({ room, msg })=>{
        setMessage(room, msg);
    });
}

function setupImportantMessage(socket){
    socket.on('importantMessage', msg=>{
        popupMessageRef.current.setMsg(msg);
    });
}

function setupEndGame(socket){
    socket.on('endGame', ()=>{
        socket.disconnect();
    });
}

function setupOnError(socket){
    socket.on('error', err=>{
        popupErrorRef.current.showError(err);
    });
}

function setupFatalError(socket, setRoom){
    socket.on('fatalError', err=>{
        socket.disconnect();
        popupErrorRef.current.showError(err, ()=>{
            window.location = window.location;
            setRoom(null);
        });
    })
}